const initialState = {
  partner: {}
};
const partnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PARTNER_DATA':
      return {
        ...state,
        partner: action.payload
      };
    default:
      return state;
  }
};

export default partnerReducer;
